import { LinkIcon } from '@heroicons/react/20/solid';
import { nothing } from 'maybeasy';
import { observer } from 'mobx-react';
import CopyToClipboardStore from '../../../../../../../../../CopyToClipboard/Store';
import Checkmark from '../../../../../../../../../Cutesies/Checkmark';
import Loader from '../../../../../../../../../Loader';
import Button from './Button';

export interface Props {
  store: CopyToClipboardStore;
  copyText: string;
}

function States({ store, copyText }: Props) {
  switch (store.state.kind) {
    case 'waiting':
      return (
        <Button store={store} copyText={copyText}>
          <div className="w-5 h-5 mr-1">
            <LinkIcon />
          </div>
        </Button>
      );
    case 'copying':
      return (
        <Button store={store} copyText={copyText}>
          <div className="w-5 h-5 mr-1">
            <Loader type="spin" text={nothing()} color="#187A90" />
          </div>
        </Button>
      );
    case 'copied':
      return (
        <Button store={store} copyText={copyText}>
          <div className="w-5 mr-1">
            <Checkmark className="fill-teal-600" />
          </div>
        </Button>
      );
  }
}

export default observer(States);
